import React, { useState, useCallback, useRef } from 'react';

import { Container, Row, Col, Heading, className } from 'aplazame-design-system';
import { useTranslate } from 'soluble-gatsby-source';

import HeaderResourcesSection from '../HeaderResourcesSection';
import CardWebinarComponent from '../CardWebinarComponent';
import CardFutureWebinarComponent from '../CardFutureWebinarComponent';


import colorStyle from "aplazame-design-system/src/scss/color.module.scss";

let HAS_INITED = false;

export default function WebinarsSection({
    title,
    subtitle,
    futureWebinars,
    pastWebinars,
    categories
}) {
    const translation = useTranslate();
    const wrapperRef = useRef();
    const [filteredFutureWebinars, setFilteredFutureWebinars] = useState(futureWebinars);
    const [filteredPastWebinars, setFilteredPastWebinars] = useState(pastWebinars);

    const onFilterChange = useCallback(
        filter => {
            if (filter && filter.slug) {
                if (futureWebinars && futureWebinars.length) {
                    setFilteredFutureWebinars(futureWebinars.filter(fw => fw.category && fw.category.slug === filter.slug));
                }
                if (pastWebinars && pastWebinars.length) {
                    setFilteredPastWebinars(pastWebinars.filter(pw => pw.category && pw.category.slug === filter.slug));
                }
            } else {
                setFilteredFutureWebinars(futureWebinars);
                setFilteredPastWebinars(pastWebinars);
            }

            if (!HAS_INITED) {
                HAS_INITED = true;
            } else if (wrapperRef && wrapperRef.current) {
                setTimeout(
                    () => {
                        const allDataSal = wrapperRef.current.querySelectorAll('[data-sal]');
                        [...allDataSal].forEach(item => {
                            item.classList.add('sal-animate');
                        });
                    },
                    200
                );
            }
        },
        [futureWebinars, pastWebinars, setFilteredFutureWebinars, setFilteredPastWebinars, wrapperRef]
    );

    return (
        <div ref={wrapperRef}>
            <HeaderResourcesSection
                title={title}
                subtitle={subtitle}
                categories={categories}
                allCategoriesTitle={translation['webinars-section.categories.all'].text}
                filterCategoriesTitle={translation['webinars-section.categories.modal.title'].text}
                onFilterChange={onFilterChange}
            />
            {filteredFutureWebinars && filteredFutureWebinars.length ? (
                <section
                    {...className(`mt-1 ${colorStyle['bg--secondary']}`)}
                >
                    <Container
                        pt={{ xs: 4, lg: 8 }}
                        pb={{ xs: 3, lg: 5 }}
                    >
                        <Row>
                            <Col
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                                style={{
                                    "--sal-delay": `1200ms`
                                }}
                            >
                                <Heading
                                    tag="h3"
                                    mb={{ xs: 4, lg: 5 }}
                                    className="h3 font-weight-bold"
                                >
                                    {translation['webinars-section.next.title'].text}
                                </Heading>
                            </Col>
                        </Row>
                        {filteredFutureWebinars.map((webinar, i) => (
                            <CardFutureWebinarComponent
                                key={i}
                                isFirstViewport={true}
                                {...webinar}
                            />
                        ))}
                    </Container>
                </section>
            ) : null}
            {filteredPastWebinars && filteredPastWebinars.length ? (
                <section>
                    <Container
                        pt={{ xs: 7, lg: filteredFutureWebinars && filteredFutureWebinars.length ? 8 : 5 }}
                        pb={{ xs: 4, lg: 15 }}
                    >
                        <Row>
                            <Col>
                                <Heading
                                    tag="h3"
                                    mb={{ xs: 7 }}
                                    className="h3 font-weight-bold"
                                    data-sal="slide-up"
                                    data-sal-easing="ease-out-quart"
                                    style={{
                                        "--sal-delay": futureWebinars && futureWebinars.length ? '' : `1200ms`
                                    }}
                                >
                                    {translation['webinars-section.past.title'].text}
                                </Heading>
                            </Col>
                            {filteredPastWebinars.map((webinar, i) => (
                                <Col
                                    key={i}
                                    col={{ md: 6, lg: 4 }}
                                    pb={{ xs: 8, lg: 5 }}
                                    data-sal="slide-up"
                                    data-sal-easing="ease-out-quart"
                                    data-sal-delay={`xs-none--lg-${(i % 3) * 100}`}
                                >
                                    <CardWebinarComponent
                                        {...webinar}
                                    />
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </section>
            ) : null}
        </div>
    );
}